var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[(_vm.loading)?_c('v-progress-linear',{attrs:{"color":"primary","indeterminate":""}}):_vm._e(),(_vm.isAuth && !_vm.loading)?_c('APPNavbar',{staticClass:"no-print"}):_vm._e(),(!_vm.loading)?_c('v-main',[_c('div',{staticClass:"app-wrap"},[_c('router-view')],1)]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }